import RofdaMapImage from "../../public/assets/images/bg/rofda-map.png";
function RofdaMap() {
    return (
        <>
            <div className="map-section-wrapper mb-100">
                <div className="container">
                    <div className="map-section">
                        <img src={RofdaMapImage} alt="Rofda Map Banner" className='img-fluid' />
                     </div>
                </div>
            </div>
        </>
    );
}
export default RofdaMap;